import { render, staticRenderFns } from "./RegisterDoctorFormV2.vue?vue&type=template&id=e92bc540&scoped=true"
import script from "./RegisterDoctorFormV2.vue?vue&type=script&lang=js"
export * from "./RegisterDoctorFormV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92bc540",
  null
  
)

export default component.exports